import { Component } from '@angular/core';

@Component({
  template: '<ui-view></ui-view>'
})
export class PasswordComponent {};
